import BaseService from './BaseService'
import * as apiroutes from '../apiRoutes'

class DocumentVersionService extends BaseService {
    constructor() {
        super(apiroutes.DOCUMENT_VERSIONS)
    }

    async getStatusSummary(params = {}) {
        return await super.customCall('GET', '/status-summary', null, params, null)
    }

    async getAll(params = {}) {
        return await super.customCall('GET', '', null, params, null)
    }

    async getById(id) {
        return await super.customCall('GET', '/' + id, null, null, null)
    }

    async update(id, data) {
        return await super.customCall('PATCH', '/' + id, data, null, 'json')
    }
}

const DocumentVersionServices = new DocumentVersionService()
export default DocumentVersionServices